export default "__VITE_ASSET__tP4SlOpw__"